// NavBar.js
import React, { useState } from 'react';
import MenuItem from './MenuItem';
import useAuth from "../hooks/useAuth";
import { GrPrevious, GrNext } from "react-icons/gr";

// Your SVG imports
import adminIcon from '../assets/uil_user.svg';
import managerIcon from '../assets/manager.svg';
import taggerIcon from '../assets/tagger.svg';
import reviewerIcon from '../assets/reviewer.svg';
import reportsIcon from '../assets/reports.svg';
import filterIcon from '../assets/filter.svg';
import historicalIcon from '../assets/historical.svg';
import bulkuploadIcon from '../assets/bulk_upload.svg';
import projectIcon from "../assets/chart-gantt.svg";
import createProfileIcon from "../assets/profile-2use.svg";
import profileDetailIcon from "../assets/profile-details.svg";
import taskIcon from "../assets/task-square.svg";
import assignIcon from "../assets/peer-review.svg";
import requestIcon from "../assets/pull.png"
import { ROLES } from './ROLES';

const NavBar = ({ isSidebarOpen }) => {
  const isOpen = isSidebarOpen;
  const [activeItem, setActiveItem] = useState('');
  const { auth } = useAuth();

  // Define menu items for each role
  const menuItems = [];

  if (auth.profile_role === ROLES.ADMIN) {
    menuItems.push({
      id: 1,
      name: 'Admin',
      path: '/projects',
      icon: <img className="w-6 h-6" src={adminIcon} alt="Admin Icon" />,
      submenu: [
        {
          id: 101,
          name: 'Projects',
          path: '/projects',
          icon: <img className="w-6 h-6" src={projectIcon} alt="Projects" />,
        },
        {
          id: 102,
          name: 'Create Profile',
          path: '/createprofile',
          icon: <img className="w-6 h-6" src={createProfileIcon} alt="Create Profile" />,
        },
      ],
    });
    menuItems.push({
      id: 2,
      name: 'Manager',
      path: '/manager',
      icon: <img className="w-6 h-6" src={managerIcon} alt="Manager Icon" />,
      submenu: [
        {
          id: 202,
          name: 'Profile Details',
          path: '/createprofilemanager',
          icon: <img className="w-6 h-6" src={createProfileIcon} alt="Create Profile" />,
        },
        {
          id: 204,
          name: 'Create Task',
          path: '/createtask',
          icon: <img className="w-6 h-6" src={taskIcon} alt="Task" />,
        },
        {
          id: 205,
          name: 'Set Reviewer',
          path: '/assigntoreviewer',
          icon: <img className="w-6 h-6" src={assignIcon} alt="Assign" />,
        },
      ],
    });
    menuItems.push({
      id: 3,
      name: 'Tagger',
      path: '/tagger',
      icon: <img className="w-6 h-6" src={taggerIcon} alt="Tagger Icon" />,
    });
    menuItems.push({
      id: 4,
      name: 'Reviewer',
      path: '/reviewer',
      icon: <img className="w-6 h-6" src={reviewerIcon} alt="Reviewer Icon" />,
    });
    menuItems.push({
      id: 5,
      name: 'Reports',
      path: '/reports',
      icon: <img className="w-6 h-6" src={reportsIcon} alt="Reports Icon" />,
    });
    menuItems.push({
      id: 6,
      name: 'Filter',
      path: '/filter',
      icon: <img className="w-6 h-6" src={filterIcon} alt="Filter Icon" />,
    });
    menuItems.push({
      id: 7,
      name: 'Bulk Upload',
      path: '/bulkupload',
      icon: <img className="w-6 h-6" src={bulkuploadIcon} alt="Bulk Icon" />,
    });
    menuItems.push({
      id: 8,
      name: 'Historical Records',
      path: '/historicalrecords',
      icon: <img className="w-6 h-6" src={historicalIcon} alt="Historical Icon" />,
    });
    menuItems.push({
      id: 9,
      name: 'Requests',
      path: '/requests',
      icon: <img className="w-6 h-6" src={requestIcon} alt="Request Icon" />,
    });
  } else if (auth.profile_role === ROLES.MANAGER) {
    menuItems.push({
      id: 2,
      name: 'Manager',
      path: '/manager',
      icon: <img className="w-6 h-6" src={managerIcon} alt="Manager Icon" />,
      submenu: [
        {
          id: 202,
          name: 'Profile Details',
          path: '/createprofilemanager',
          icon: <img className="w-6 h-6" src={createProfileIcon} alt="Create Profile" />,
        },
        {
          id: 204,
          name: 'Create Task',
          path: '/createtask',
          icon: <img className="w-6 h-6" src={taskIcon} alt="Task" />,
        },
        {
          id: 205,
          name: 'Set Reviewer',
          path: '/assigntoreviewer',
          icon: <img className="w-6 h-6" src={assignIcon} alt="Assign" />,
        },
      ],
    });
    menuItems.push({
      id: 8,
      name: 'Historical Records',
      path: '/historicalrecords',
      icon: <img className="w-6 h-6" src={historicalIcon} alt="Historical Icon" />,
    });
    menuItems.push({
      id: 3,
      name: 'Tagger',
      path: '/tagger',
      icon: <img className="w-6 h-6" src={taggerIcon} alt="Tagger Icon" />,
    });
    menuItems.push({
      id: 4,
      name: 'Reviewer',
      path: '/reviewer',
      icon: <img className="w-6 h-6" src={reviewerIcon} alt="Reviewer Icon" />,
    });
    menuItems.push({
      id: 5,
      name: 'Reports',
      path: '/reports',
      icon: <img className="w-6 h-6" src={reportsIcon} alt="Reports Icon" />,
    });
    menuItems.push({
      id: 6,
      name: 'Filter',
      path: '/filter',
      icon: <img className="w-6 h-6" src={filterIcon} alt="Filter Icon" />,
    });
    menuItems.push({
      id: 7,
      name: 'Bulk Upload',
      path: '/bulkupload',
      icon: <img className="w-6 h-6" src={bulkuploadIcon} alt="Bulk Icon" />,
    });
  } else if (auth.profile_role === ROLES.TAGGER) {
    menuItems.push({
      id: 3,
      name: 'Tagger',
      path: '/tagger',
      icon: <img className="w-6 h-6" src={taggerIcon} alt="Tagger Icon" />,
    });
    menuItems.push({
      id: 5,
      name: 'Reports',
      path: '/reports',
      icon: <img className="w-6 h-6" src={reportsIcon} alt="Reports Icon" />,
    });
  } else if (auth.profile_role === ROLES.REVIEWER) {
    menuItems.push({
      id: 4,
      name: 'Reviewer',
      path: '/reviewer',
      icon: <img className="w-6 h-6" src={reviewerIcon} alt="Reviewer Icon" />,
    });
    menuItems.push({
      id: 5,
      name: 'Reports',
      path: '/reports',
      icon: <img className="w-6 h-6" src={reportsIcon} alt="Reports Icon" />,
    });
  }

  return (
    <div className="relative z-10">
      <div className="sidebar pl-5 transition-all duration-300 ease-in-out" style={{ width: isOpen ? "236px" : "68px" }}>
        {/* <div
          className={`absolute top-9 transition-all duration-300 ease-in-out ${isOpen ? 'left-[250px]' : 'left-[82px]'}`}
        >
          <div
            className="w-6 h-6 border border-primary-color min-w-[28px] min-h-[28px] rounded-full flex items-center justify-center bg-white shadow-md cursor-pointer"
            onClick={toggleSidebar}
          >
            {isOpen ? <GrPrevious className="text-primary-color" /> : <GrNext className="text-primary-color" />}
          </div>
        </div> */}

        <ul className="mt-3 space-y-2">
          {menuItems.map((item) => (
            <MenuItem
              key={item.id}
              item={item}
              isOpen={isOpen}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NavBar;
